var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNyttigMat = function SvgNyttigMat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4baa76",
    d: "M60.248 15.958c10.231 14.082 6.019 27.025-10.846 39.278s-30.37 12.902-40.601-1.18-13.327-37.549 3.553-49.813c11.66-8.494 37.663-2.367 47.894 11.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.457 44.019c-6.655 0-12.07-5.414-12.07-12.07s5.415-12.069 12.07-12.069 12.07 5.415 12.07 12.07-5.415 12.069-12.07 12.069zm0-25.012A12.96 12.96 0 0 0 18.515 31.95a12.96 12.96 0 0 0 12.942 12.943c7.137 0 12.943-5.807 12.943-12.943s-5.806-12.943-12.943-12.943zm.342 21.614a8.34 8.34 0 0 1-8.33-8.33 8.34 8.34 0 0 1 8.33-8.33 8.34 8.34 0 0 1 8.33 8.33 8.34 8.34 0 0 1-8.33 8.33zm0-17.526a9.21 9.21 0 0 0-9.197 9.196 9.21 9.21 0 0 0 9.197 9.196 9.21 9.21 0 0 0 9.196-9.196 9.21 9.21 0 0 0-9.196-9.196z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 6,
    height: 30,
    x: 43,
    y: 16,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.895 16.976h4.439v28.656h-4.44V16.976z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M46.468 31.386v-1.107a.427.427 0 0 0-.134-.312l-.54-.513a3.314 3.314 0 0 1-.82-3.6l2.342-6.125v11.657h-.848zm-.16 12.8v-.666h1.168v.666a.585.585 0 0 1-.996.413.585.585 0 0 1-.171-.413zm.16-1.526h.848V32.246h-.848V42.66zm-.858-12.196v.922h-.16v12.8a1.445 1.445 0 0 0 1.442 1.446 1.445 1.445 0 0 0 1.442-1.445V31.386h-.16v-13.98a.429.429 0 0 0-.83-.154l-3.17 8.294a4.171 4.171 0 0 0 1.03 4.533l.407.384z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 7,
    height: 30,
    x: 13,
    y: 16,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.065 16.976h5.96v28.656h-5.96V16.976z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.025 44.772a.585.585 0 0 1-.584-.585v-.667h1.167v.667a.585.585 0 0 1-.583.585zm-.404-2.112h.848V32.246h-.848V42.66zm2.975-25.684a.43.43 0 0 0-.43.43v5.938a1.272 1.272 0 0 1-1.268 1.27.43.43 0 0 0-.429.43v6.342h-.848v-6.341a.43.43 0 0 0-.428-.43 1.271 1.271 0 0 1-1.269-1.271v-5.938a.43.43 0 1 0-.858 0v5.938a2.133 2.133 0 0 0 1.697 2.087v5.955h-.18v12.8a1.445 1.445 0 0 0 1.442 1.446 1.445 1.445 0 0 0 1.442-1.445V31.386h-.14V25.43a2.134 2.134 0 0 0 1.697-2.088v-5.937a.43.43 0 0 0-.428-.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.768 23.095c.188 0 .34-.191.34-.426v-5.28c0-.235-.152-.425-.34-.425s-.34.19-.34.426v5.279c0 .235.152.425.34.425zm2.044 0c.188 0 .34-.191.34-.426v-5.28c0-.235-.152-.425-.34-.425s-.34.19-.34.426v5.279c0 .235.152.425.34.425z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgNyttigMat;